import axios from 'axios';
import { SALES } from '../constants';

export const ping = async (accessToken, initiateUiResponse, { env, isWCFlow } = {}) => {
  try {
    await axios.get(initiateUiResponse.REACT_APP_PING_URL, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        appid: SALES,
        'Content-Type': 'application/json',
      },
    });
  } catch (e) {
    return e;
  }
  return 0;
};
